<app-search
  [focusedAsDefault]="false"
  (searchChanged)="search$.next($event)"
  [clearCodeAfterChange]="false"
  />

<nz-table
  style="margin-top: 20px;"
  #tableRef
  [nzData]="articles"
  [nzLoading]="loading"
  [nzFrontPagination]="true"
  [nzPageSize]="10"
  nzSize="small"
  nzShowSizeChanger
  >
  <thead>
    <tr>
      <th>#ID</th>
      <th>Name</th>
      <th>Bestellnummer</th>
      <th nzWidth="70px"></th>
    </tr>
  </thead>
  <tbody>
    @for (article of tableRef.data; track article) {
      <tr>
        <td>{{ article.id }}</td>
        <td>{{ article.name }}</td>
        <td>{{ article.orderNumber }}</td>
        <td nzRight>
          <div class="actions">
            <app-add-edit-article-modal #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Artikel bearbeiten: ' + article.name"
                  (pressed)="modal.showModal(article)"
                ></app-icon-button>
              </span>
            </app-add-edit-article-modal>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
